/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Other_S3Inputs */

const en_fc_dl_other_s3 = /** @type {(inputs: Fc_Dl_Other_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefer not to set anything up? Install the desktop app from the other tabs, or check the Use Online page for browser options.`)
};

/**
* | output |
* | --- |
* | "Prefer not to set anything up? Install the desktop app from the other tabs, or check the Use Online page for browser options." |
*
* @param {Fc_Dl_Other_S3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_other_s3 = /** @type {((inputs?: Fc_Dl_Other_S3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Other_S3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_other_s3(inputs)
});
export { fc_dl_other_s3 as "fc.dl.other.s3" }